/**
 * Date formatting utility functions
 * All dates should be displayed in dd-mmm-yyyy format
 */

/**
 * Format date to dd-mmm-yyyy format
 * @param {Date|string} dateInput - Date object or date string
 * @returns {string} Formatted date in dd-mmm-yyyy format
 */
export const formatDateToDDMMMYYYY = (dateInput) => {
  if (!dateInput) return '';
  
  const date = new Date(dateInput);
  if (isNaN(date.getTime())) {
    console.warn('Invalid date provided to formatDateToDDMMMYYYY:', dateInput);
    return '';
  }
  
  const day = String(date.getDate()).padStart(2, '0');
  const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
                     'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  const month = monthNames[date.getMonth()];
  const year = date.getFullYear();
  
  return `${day}-${month}-${year}`;
};

/**
 * Format date to dd-mmm-yyyy format with time (for comments and timestamps)
 * @param {Date|string} dateInput - Date object or date string
 * @returns {string} Formatted date in dd-mmm-yyyy, h:mm AM/PM format
 */
export const formatDateTimeToDDMMMYYYY = (dateInput, isTime = true) => {
  if (!dateInput) return '';
  
  const date = new Date(dateInput);
  if (isNaN(date.getTime())) {
    console.warn('Invalid date provided to formatDateTimeToDDMMMYYYY:', dateInput);
    return '';
  }
  
  const day = String(date.getDate()).padStart(2, '0');
  const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
                     'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  const month = monthNames[date.getMonth()];
  const year = date.getFullYear();
  
  // Format time
  let hours = date.getHours();
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const ampm = hours >= 12 ? 'PM' : 'AM';
  hours = hours % 12;
  hours = hours ? hours : 12; // 0 should be 12
  if(isTime) {
    return `${day}-${month}-${year}, ${hours}:${minutes} ${ampm}`;
  } else {
    return `${day}-${month}-${year}`;
  }
  
};

/**
 * Format date for form inputs (yyyy-mm-dd format)
 * @param {Date|string} dateInput - Date object or date string
 * @returns {string} Formatted date in yyyy-mm-dd format for form inputs
 */
export const formatDateForInput = (dateInput) => {
  if (!dateInput) return '';
  
  const date = new Date(dateInput);
  if (isNaN(date.getTime())) {
    console.warn('Invalid date provided to formatDateForInput:', dateInput);
    return '';
  }
  
  const yyyy = date.getFullYear();
  const mm = String(date.getMonth() + 1).padStart(2, '0');
  const dd = String(date.getDate()).padStart(2, '0');
  
  return `${yyyy}-${mm}-${dd}`;
};

/**
 * Legacy formatDate function for backward compatibility
 * @deprecated Use formatDateToDDMMMYYYY instead
 */
export const formatDate = formatDateForInput;
